var _title, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgMinus = function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 2,
    viewBox: "0 0 9 2"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "+")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "minus_svg__a",
    d: "M8.216 0v1.872H0V0h5.148z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#minus_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#minus_svg__a"
  }))));
};
export default SvgMinus;